module.exports = __webpack_public_path__ + "img/ys.63048c9a.png";